export const colours: Record<
  string,
  {
    swatchName: string;
    isWhiteReadable: boolean;
    colour: string;
    frenchSwatchName: string;
  }
> = {
  Black: {
    swatchName: 'Black',
    isWhiteReadable: true,
    colour: 'black',
    frenchSwatchName: 'Noir',
  },
  Blue: {
    swatchName: 'Blue',
    isWhiteReadable: true,
    colour: 'blue',
    frenchSwatchName: 'Bleu',
  },
  Grey: {
    swatchName: 'Grey',
    isWhiteReadable: true,
    colour: 'grey',
    frenchSwatchName: 'Gris',
  },
  Multicolour: {
    swatchName: 'Multicolour',
    isWhiteReadable: true,
    colour:
      'radial-gradient(circle at 50% 0, rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0) 70.71%), radial-gradient(circle at 6.7% 75%, rgba(0, 0, 255, 0.5), rgba(0, 0, 255, 0) 70.71%), radial-gradient(circle at 93.3% 75%, rgba(0, 255, 0, 0.5), rgba(0, 255, 0, 0) 70.71%) beige',
    frenchSwatchName: 'Multicolore',
  },
  Green: {
    swatchName: 'Green',
    isWhiteReadable: true,
    colour: 'green',
    frenchSwatchName: 'Vert',
  },
  Brown: {
    swatchName: 'Brown',
    isWhiteReadable: true,
    colour: 'brown',
    frenchSwatchName: 'Brun',
  },
  White: {
    swatchName: 'White',
    isWhiteReadable: false,
    colour: 'white',
    frenchSwatchName: 'Blanc',
  },
  Pink: {
    swatchName: 'Pink',
    isWhiteReadable: true,
    colour: 'pink',
    frenchSwatchName: 'Rose',
  },
  Red: {
    swatchName: 'Red',
    isWhiteReadable: true,
    colour: 'red',
    frenchSwatchName: 'Rouge',
  },
  Orange: {
    swatchName: 'Orange',
    isWhiteReadable: true,
    colour: 'orange',
    frenchSwatchName: 'Orange',
  },
  Teal: {
    swatchName: 'Teal',
    isWhiteReadable: true,
    colour: 'teal',
    frenchSwatchName: 'Sarcelle',
  },
  Purple: {
    swatchName: 'Purple',
    isWhiteReadable: true,
    colour: 'purple',
    frenchSwatchName: 'Violet',
  },
  Beige: {
    swatchName: 'Beige',
    isWhiteReadable: false,
    colour: 'beige',
    frenchSwatchName: 'Beige',
  },
  Yellow: {
    swatchName: 'Yellow',
    isWhiteReadable: false,
    colour: 'yellow',
    frenchSwatchName: 'Jaune',
  },
  Burgundy: {
    swatchName: 'Burgundy',
    isWhiteReadable: true,
    colour: 'maroon',
    frenchSwatchName: 'Bourgogne',
  },
  Silver: {
    swatchName: 'Silver',
    isWhiteReadable: true,
    colour: 'silver',
    frenchSwatchName: 'Argent',
  },
  Clear: {
    swatchName: 'Clear',
    isWhiteReadable: false,
    colour: 'clear',
    frenchSwatchName: 'Claire',
  },
  Gold: {
    swatchName: 'Gold',
    isWhiteReadable: true,
    colour: 'gold',
    frenchSwatchName: 'Gold',
  },
};
